module.exports = __webpack_public_path__ + "img/douji2.f670064e.png";